// extracted by mini-css-extract-plugin
export var change = "_44-1";
export var changeList = "_44-0";
export var changePath = "_44-2";
export var diffArrow = "_44-5";
export var diffRow = "_44-3";
export var diffValue = "_44-4";
export var error = "_44-8";
export var notice = "_44-9";
export var result = "_44-6";
export var success = "_44-7";